import About from "./Parts/About";
import Hero from "./Parts/Hero";
import Pre from "./Parts/Pre";
import Reviews from "./Parts/Reviews";
import Services from "./Parts/Services";
import Strength from "./Parts/Strength";
import Where from "./Parts/Where";

import value from "../../assets/value.svg";
import hero from "../../assets/hero.webp";
// import cremation from "../../assets/cremation.webp";
import cremation from "../../assets/urna.webp";
import contract from "../../assets/contract.webp";
import Button from "../../components/Button";
import phone from "../../assets/phone.svg";
import video from "../../assets/video.svg";
import chat from "../../assets/chat.svg";
import { useState } from "react";
import Video from "./Parts/Video";

export default function Home() {
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>
      {showVideo && <Video onClose={() => setShowVideo(false)} />}

      <Hero onVideo={() => setShowVideo(true)} />
      <br />
      <br />
      {/* cremation */}
      <Pre
        btnText1="Scrivici su WhatsApp"
        btnText="Chiama per un preventivo"
        id="cremation"
        heroTitle="Costi Cremazione"
        heroSubtitle={
          <>
            <h5>
              <strong>Con noi, € 2.500 come sotto descritto</strong>
              <br />
              <i>
                <small>(IVA inclusa, detraibile)</small>
              </i>
            </h5>
            <div
              className="btn-video-modal"
              onClick={() => setShowVideo(true)}
              style={{ scale: "0.8" }}
            >
              <Button text="Guarda il Video sulla Cremazione" icon={video} />
            </div>
            <br />
            Il nostro servizio comprende:{" "}
            <strong>
              Cremazione, Urna, Feretro in legno naturale con verniciatura
              ecologica, Trasporto verso il sito crematorio.
            </strong>
            <br />
            <br />È inoltre incluslo il{" "}
            <strong>
              Disbrigo documentazione per autorizzazione alla cremazione e
              trasporto fuori comune
            </strong>{" "}
            con marche da bollo e diritti Asp.
            <br />
            <br />
            <strong>
              Contattaci per ricevere subito il preventivo su WhatsApp o per
              ulteriori informazioni.
            </strong>
            <br />
            <br />
            <Button
              id="cta-cremation-1"
              onClickLink={`tel:${process.env.REACT_APP_PHONE_NUMBER}`}
              text="Chiama Subito (24h)"
              icon={phone}
              className="tag-manager-call w100 h"
            />
            <Button
              id="cta-cremation-2"
              onClickLink={`https://api.whatsapp.com/send?phone=${process.env.REACT_APP_PHONE_NUMBER}&text=Salve, vorrei sapere di più sui vostri servizi.`}
              secondary
              icon={chat}
              text="Scrivici su WhatsApp"
              className="tag-manager-call w100 mt-1 h"
            />
          </>
        }
        steps={[
          { text: "Camera ardente", icon: value },
          { text: "Documenti Cremazione", icon: value },
          { text: "Autofunebre", icon: value },
          { text: "Feretro in legno naturale non trattato", icon: value },
          { text: "Urna cineraria", icon: value },
          { text: "Gestione della cremazione", icon: value },
          { text: "Documenti destinazione ceneri", icon: value },
          { text: "Consulenza su dispersione o custodia urne", icon: value },
          { text: "Assistenza rimpatrio/espatrio urne", icon: value },
          { text: "Streaming del funerale su richiesta", icon: value },
        ]}
        mainTitle="Cremazioni in tutta la Sicilia"
        text1={
          <>
            <strong>Più di 40.000 famiglie ci hanno scelto in Sicilia.</strong>{" "}
            Dal primo contatto offriamo un preventivo completo, trasparente e
            dettagliato, valido anche nel tempo.
          </>
        }
        text2={
          <>
            <strong>📝 Volontà alla Cremazione</strong>
            <ul className="list-disc list-inside mt-2 text-sm">
              <li>Gestione completa delle pratiche</li>
              <li>Supporto anche con familiari lontani</li>
              <li>Soluzioni rapide e conformi alla legge</li>
            </ul>
          </>
        }
        text3={
          <>
            <strong>⚱️ Destinazione delle Ceneri</strong>
            <ul className="list-disc list-inside mt-2 text-sm">
              <li>Custodia in casa, tumulazione o dispersione</li>
              <li>Pratiche e autorizzazioni incluse</li>
              <li>Organizzazione della cerimonia</li>
            </ul>
          </>
        }
        text4={
          <>
            <strong>📄 Contratti in Vita</strong>
            <ul className="list-disc list-inside mt-2 text-sm">
              <li>Personalizzabile e rateizzabile</li>
              <li>Zero pensieri per i tuoi cari</li>
              <li>Valido ovunque in Sicilia</li>
              <li>
                <u>
                  <a href="#contract">Scopri di più sul contratto in vita</a>
                </u>
              </li>
            </ul>
          </>
        }
        text5={
          <>
            <strong>🌿 Ecologia & Sensibilità</strong>
            <ul className="list-disc list-inside mt-2 text-sm">
              <li>Materiali naturali e non trattati</li>
              <li>Servizio rispettoso dell’ambiente</li>
              <li>Forno crematorio a basse emissioni</li>
            </ul>
          </>
        }
        image={cremation}
      />
      <br />
      <br />

      {/* funeral */}
      <Pre
        btnText1="Scrivici su WhatsApp"
        btnText="Chiama per un preventivo"
        id="funeral"
        dark
        heroTitle="Funerali"
        heroSubtitle="Organizzeremo il funerale con professionalità e rispetto. Non dovrai pensare a niente."
        steps={[
          { text: "Camera ardente", icon: value },
          { text: "Auto funebre", icon: value },
          { text: "Feretro in legno", icon: value },
          { text: "Frigorifero salma", icon: value },
          { text: "Composizione salma", icon: value },
          { text: "Disbrigo documentazione", icon: value },
          { text: "Fiori", icon: value },
          { text: "Ogni aspetto Cimiteriale", icon: value },
        ]}
        mainTitle="Interveniamo per Servizi Funebri in tutta la Sicilia"
        text1="La trasparenza sui costi e la chiarezza su ciò che è fornito rappresentano il primo motivo di attenzione del cliente verso la nostra impresa di onoranze funebri a Catania e provincia."
        text2="La nostra impresa fornirà continuo supporto 24h ai familiari esonerandoli da qualsiasi incombenza organizzativa e burocratica."
        image={hero}
      />

      <br />
      <br />
      {/* contract */}
      <Pre
        btnText="Chiama per maggiori informazioni"
        btnText1="Scrivici su WhatsApp"
        id="contract"
        heroTitle="Contratto in Vita"
        heroSubtitle="Una scelta personale di sensibilità verso i propri cari, allevia le loro responsabilità in un momento difficile"
        steps={[
          { text: "Camera ardente", icon: value },
          { text: "Auto funebre", icon: value },
          { text: "Feretro in legno", icon: value },
          { text: "Frigorifero salma", icon: value },
          { text: "Disbrigo documentazione", icon: value },
          { text: "Ogni dettaglio aggiuntivo", icon: value },
        ]}
        mainTitle="Contratto in vita"
        text1="Il contratto in vita, è una scelta di sensibilità verso i propri familiari ai quali non si vuole lasciare nessuna pendenza finanziaria e organizzativa. Parisi Mario Servizi Funebri è la prima impresa in Sicilia ad offrire la possibilità di stipulare un contratto in vita per un funerale."
        text2={
          <>
            <strong>
              Una sensibilità verso i propri cari a non lasciare nessun onere
              finanziario e organizzativo, ti permette di:
            </strong>
            <p>
              <ul>
                <li>
                  Esprimere liberamente la propria volontà alla cremazione
                </li>
                <li>
                  Assicurarsi di includere nel contratto la documentazione
                  necessaria a tale volontà
                </li>
                <li>
                  Essere sicuri che le proprie volontà, ad esempio la
                  dispersione in natura o scelte sulla celebrazione, vengano
                  rispettate
                </li>
                <li>
                  Cominciare a pagare anche a rate, diluendo l’importo nel tempo
                </li>
              </ul>
            </p>
          </>
        }
        // text3="Inoltre, grazie alla nostra collaborazione con Assicurazioni Generali, il contratto offre numerosi vantaggi, tra questi in caso di premorienza senza aver completato il pagamento delle rate, sarà l’assicurazione stessa ad intervenire a completamento dell’importo totale"
        text3=""
        image={contract}
      />
      <Services />
      <br />
      <br />
      <About />
      <br />
      <br />
      <hr />
      <br />
      <br />
      <div className="d-none d-md-block">
        <br />
        <br />
        <Strength />
        <br />
        <br />
      </div>
      <Reviews />

      <br />
      <br />
      <Where />
    </>
  );
}
